<bn-web-ui-toastr-component />
<router-outlet />
